import { TransactionDetailSection } from '@/components/DataReflection/TransactionDetailSection/TransactionDetailSection';
import type { TransactionDetailSectionProps } from '@/components/DataReflection/TransactionDetailSection/types';
import { useTranslation } from '@/i18n';
import React from 'react';
import styles from './DetailList.module.scss';

export const DetailList: React.FC<
  TransactionDetailSectionProps & {
    isLoadingPulldownOptions?: boolean;
  }
> = (props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.detailList}>
      <div className={styles.title}>
        {t('approve_invoice_transactionDetail_headerDetail')}
      </div>
      <TransactionDetailSection {...props} />
    </div>
  );
};
